import React from 'react'
import '../resume.css'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { encode } from "base-64";

function ResumeFields({ checked, onCheckChange, label, userdetail, details, img, labelID, children }) {
    return (
        <div className={`cursor-pointer select-none ${!img && 'h-full'}`}>
            <input type="checkbox" checked={checked} onChange={onCheckChange} name='resume' id={`resumeCheckBox${encode(label ? label : labelID)}`} className="hidden resumeCheckBox" />
            {userdetail ? <label htmlFor={`resumeCheckBox${encode(label ? label : labelID)}`} className="check--box block relative w-full h-full cursor-pointer bg-white px-3 py-2 rounded-xl hover:shadow-md transition duration-500">
                {img ? "" : <CheckCircleIcon className="checkCircle absolute right-4 transition duration-500" />}
                <span className='manpro font-semibold text-lg block mb-2'>
                    {label ? label : img}
                </span>
                <div className="">
                    <span className="manpro font-medium text-sm">
                        {details}
                    </span>
                </div>
            </label> : 
            <label htmlFor={`resumeCheckBox${encode(label ? label : labelID)}`} className="check--box block relative w-full h-full cursor-pointer bg-white px-3 py-3 rounded-xl hover:shadow-md transition duration-500">
                <CheckCircleIcon className="checkCircle absolute right-4 transition duration-500" />
                {children}
            </label>}
        </div>
    )
}

export default ResumeFields
